module.exports = __webpack_public_path__ + "static/dreamvegas-65fb7828719754e1286b9c718a35fb84.jpg";